import { customizeError } from '@chilecompra/react-kit/errors'
import { formatDNI } from '@chilecompra/react-kit/utils'
import {
  REACT_APP_API_BASE_SELLER_URL,
  REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS,
  REACT_APP_UNIQUE_PASS_APP
} from '../../config/settings/environment'
import { makeActionCreator } from '../../config/store/utils'
import { getTaxesKeyToken, getTaxesKeyUser } from '../../services/auth'

export const GET_TAXES_KEY_TOKEN = 'GET_TAXES_KEY_TOKEN'
export const GET_TAXES_KEY_TOKEN_ERROR = 'GET_TAXES_KEY_TOKEN_ERROR'
export const GET_TAXES_KEY_TOKEN_SUCCESS = 'GET_TAXES_KEY_TOKEN_SUCCESS'
export const onGetTaxesKeyToken = makeActionCreator(GET_TAXES_KEY_TOKEN)
export const onGetTaxesKeyTokenError = makeActionCreator(GET_TAXES_KEY_TOKEN_ERROR, 'payload')
export const onGetTaxesKeyTokenThunk = payload => async dispatch => {
  dispatch(onGetTaxesKeyToken())

  try {
    const backup = JSON.parse(localStorage.getItem('registerWizardBackup'))
    if (!backup) {
      throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
    }

    const { data } = await getTaxesKeyToken({ code: payload.code, state: payload.csrfToken }).catch(() => {
      throw customizeError({ code: 400, originalError: backup, reason: 'SOMETHING_WENT_WRONG_ERROR' })
    })

    return dispatch(onGetTaxesKeyUserThunk({ backup, token: data.payload.access_token }))
  } catch (error) {
    const { originalError: backup, reason } = error.toObject()

    localStorage.removeItem('registerWizardBackup')

    return dispatch(onGetTaxesKeyTokenError({ backup, reason }))
  }
}

export const GET_TAXES_KEY_USER = 'GET_TAXES_KEY_USER'
export const GET_TAXES_KEY_USER_ERROR = 'GET_TAXES_KEY_USER_ERROR'
export const GET_TAXES_KEY_USER_SUCCESS = 'GET_TAXES_KEY_USER_SUCCESS'
export const onGetTaxesKeyUser = makeActionCreator(GET_TAXES_KEY_USER)
export const onGetTaxesKeyUserError = makeActionCreator(GET_TAXES_KEY_USER_ERROR, 'payload')
export const onGetTaxesKeyUserSuccess = makeActionCreator(GET_TAXES_KEY_USER_SUCCESS, 'payload')
export const onGetTaxesKeyUserThunk = payload => async dispatch => {
  dispatch(onGetTaxesKeyUser())
  localStorage.removeItem('registerWizardBackup')

  try {
    const { data } = await getTaxesKeyUser({ token: payload.token }).catch(() => {
      throw customizeError({ code: 400, reason: 'SOMETHING_WENT_WRONG_ERROR' })
    })
    const [entity = {}] = data.payload?.entities || []
    const formattedDNI = formatDNI(payload.backup?.business?.dni, 2)
    const taxesKeyDNI = `${entity?.rut?.base}-${entity?.rut?.dv}`.toUpperCase()
    const taxesKeyDNICheck =
      REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === true || REACT_APP_FEATURE_FLAG_TAXES_KEY_CHECKS === 'true'
    if (formattedDNI !== taxesKeyDNI && taxesKeyDNICheck) {
      throw customizeError({ code: 400, originalError: payload.backup, reason: 'DNI_DOES_NOT_MATCH_TAXES_KEY_ERROR' })
    }

    return dispatch(
      onGetTaxesKeyUserSuccess({
        backup: payload.backup,
        name: payload.backup?.business?.name || entity?.razonSocial
      })
    )
  } catch (error) {
    const { originalError: backup, reason } = error.toObject()

    return dispatch(onGetTaxesKeyUserError({ backup, reason }))
  }
}

export const onSignInTaxesKeyThunk = payload => (_, getState) => {
  let registerWizardState = getState().registerWizard
  const taxesKeyURL = `${REACT_APP_API_BASE_SELLER_URL}/v1/sii/clave-tributaria/authentication?csrf=${payload.csrfToken}&aplicativo=${REACT_APP_UNIQUE_PASS_APP}`
  if (payload.isRecoveryAdmin) {
    registerWizardState = { ...registerWizardState, isRecoveryAdmin: true, isTaxesKey: true }
  }

  localStorage.setItem(
    'registerWizardBackup',
    JSON.stringify({
      ...registerWizardState,
      business: { ...registerWizardState.business, dni: payload.dni },
      flow: { ...registerWizardState.flow }
    })
  )

  window.location.href = taxesKeyURL
}
